const mergeSearchParams = (
  params: URLSearchParams | string,
  newParams: URLSearchParams | string
) => {
  const mergedParams = new URLSearchParams(params);
  const newSearchParams = new URLSearchParams(newParams);

  newSearchParams.forEach((value, key) => {
    mergedParams.set(key, value);
  });

  return mergedParams;
};

export default mergeSearchParams;
